import { articleLink, maxString } from '@components/config/helpers'
import { useTheme } from '@emotion/react'
import dayjs from 'dayjs'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import PageTitle from '../Reusables/PageTitle'
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import DefaultButton from '../Reusables/Theme/DefaultButton'

const RecentArticles = ({ type, recentArticles }) => {
    const theme = useTheme();
    return (
        <div>
            <PageTitle>Recent Articles</PageTitle>

            <Grid rowSpacing={2} container>
                {recentArticles.map((article, idx) => (
                    <Grid item xs={12}>
                        <Link href={article.image} title={article.image} alt={article.image}>
                            <Box sx={{
                                height: {
                                    xs: '100px',
                                    lg: '200px'
                                }
                            }} className="position-relative">

                                <Image
                                    lazy="true"
                                    src={article.image}
                                    alt={article.title}
                                    title={article.title}
                                    fill
                                    sizes="(max-width: 768px) 100vw,
                                    (max-width: 1200px) 50vw,
                                    33vw"
                                    quality={100}
                                />
                                <Box sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                    position: 'relative',
                                    left: '2%',
                                    top: '2%',
                                    width: '50px',
                                    maxWidth: '50px'
                                }} className="floating-calendar text-center p-2">
                                    <Typography className="f-size_4">{dayjs(article.date).format('DD')}</Typography>
                                    <Typography className="f-size_4">{dayjs(article.date).format('MMM')}</Typography>
                                </Box>

                            </Box>
                            <Typography component="p" className="mt-2">
                                <Typography component="span">Post by: </Typography>
                                <Typography component="i" color="primary">{article.display_name}</Typography>
                                <Typography color="grey" className="ml-3" component="span">{dayjs(article.date).format('DD/MM/YYYY')}</Typography>
                            </Typography>

                            <div className="fs-12" dangerouslySetInnerHTML={{
                                __html: maxString(article.content, 130)
                            }} />


                        </Link>
                        <Link href={articleLink(type, article.date, article.slug)}>
                            <DefaultButton variant="outlined" className="rounded" color="primary">
                                Read More
                            </DefaultButton>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

export default RecentArticles